import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(({ palette }) => ({
    all: {
        backgroundColor: palette.default.main,
        color: "#FFF",
    },
    circular: {
        borderRadius: "50%",
    },
    discord: {
        "&:hover": {
            backgroundColor: "#5865F2",
        },
        backgroundColor: "#5865F2",
    },
    elama: {
        "&:hover": {
            backgroundColor: "#3A64F8",
        },
        backgroundColor: "#3A64F8",
    },
    facebook: {
        "&:hover": {
            backgroundColor: "#3C5A99",
        },
        backgroundColor: "#3C5A99",
    },
    icon: {
        color: palette.background.paper,
        "$youtube &": {
            width: "100%",
            height: "100%",
        },
    },
    iconBack: {
        alignItems: "center",
        boxShadow: "none",
        display: "inline-flex",
        height: 38,
        justifyContent: "center",
        minHeight: 0,
        minWidth: 0,
        width: 38,
    },
    iconBack_size_small: {
        width: 24,
        height: 24,
    },
    instagram: {
        "&:hover": {
            backgroundColor: "#DD2A7B",
        },
        backgroundColor: "#DD2A7B",
    },
    instagram_business: {
        "&:hover": {
            background: "radial-gradient(circle at 30% 107%, #fde4a9 0%, #fd5949 45%,#d6249f 60%,#285AEB 90%)",
        },
        background: "radial-gradient(circle at 30% 107%, #fde4a9 0%, #fd5949 45%,#d6249f 60%,#285AEB 90%)",
    },
    linkedin: {
        "&:hover": {
            backgroundColor: "#0366C3",
        },
        backgroundColor: "#0366C3",
    },
    ok: {
        "&:hover": {
            backgroundColor: "#FF7700",
        },
        backgroundColor: "#FF7700",
    },
    pinterest: {
        "&:hover": {
            backgroundColor: "#CB1F24",
        },
        backgroundColor: "#CB1F24",
    },
    rounded: {
        borderRadius: 4,
    },
    telegram: {
        "&:hover": {
            backgroundColor: "#0088CC",
        },
        backgroundColor: "#0088CC",
    },
    telegram_mtproto: {
        position: "relative",
        backgroundColor: "#0088CC",
        border: "0.2cqi solid transparent",
        background: "linear-gradient(#0088CC, #0088CC) padding-box, linear-gradient(135deg, #0DC244 0%, #3e5a58 60%, #0A90DA 100%) border-box",
        "&:after": {
            content: "''",
            position: "absolute",
            inset: "1%",
            border: "0.15cqi solid #ffffff",
            borderRadius: "inherit",
        },
        "&$iconBack_size_small": {
            border: "1px solid transparent",
            "&:after": {
                inset: "1px",
                border: "1px solid #ffffff",
            },
        },
    },
    tenchat: {
        "&:hover": {
            backgroundColor: "#FC3234",
        },
        backgroundColor: "#FC3234",
    },
    tiktok: {
        "&:hover": {
            backgroundColor: "#000",
        },
        background: "#000",
    },
    twitter: {
        "&:hover": {
            backgroundColor: "#000000",
        },
        backgroundColor: "#000000",
    },
    viber: {
        "&:hover": {
            backgroundColor: "#8F5DB7",
        },
        backgroundColor: "#8F5DB7",
    },
    vk: {
        "&:hover": {
            backgroundColor: "#046ee8",
        },
        backgroundColor: "#0077ff",
    },
    youtube: {
        backgroundColor: "transparent",
        "&:hover": {
            backgroundColor: "transparent",
        },
    },
    yandex: {
        "&:hover": {
            backgroundColor: "#fc3f1d",
        },
        backgroundColor: "#fc3f1d",
    },
    google: {
        "&:hover": {
            backgroundColor: "#f6f7f9",
        },
        backgroundColor: "#f6f7f9",
        border: "1px solid #c9cacb",
    },
    max: {
        "&:hover": {
            backgroundColor: "#4b42e7",
        },
        backgroundColor: "#4b42e7",
    },
}));
//# sourceMappingURL=ui_social_icon.css.js.map